<template>
    <div class="stock-list-item" @click="$emit('click')" :style="itemHeight ? { height: itemHeight + 'px' } : null">
        <div class="flex title">
            <div class="item-one">
                <p class="list-title">{{ item.name }}</p>
                <p class="desc">
                    <span class="import" :style="{ color: mktColor[item.mkt] ? mktColor[item.mkt][theme] : mktColor.default[theme] }">
                        {{ item.mkt == 'mf' ? item.currency.toUpperCase() : item.mkt.toUpperCase() }}
                    </span>
                    {{ item.ISIN || item.rawSymbol }}
                </p>
            </div>
            <div class="item-two">
                <div class="price">{{ item.priceText }}</div>
                <div class="night-price" v-show="showNight">{{ item.nightPriceText }}</div>
            </div>
        </div>
        <div class="item-three">
            <div class="chgpct" :style="item.styleObject">
                {{ (item.chgPct > 0 && String(item.chgPctText).indexOf('+') === -1) ? '+' + item.chgPctText : item.chgPctText }}
            </div>
            <div class="night-three" v-show="showNight">
                <div class="night-chg">{{ item.nightChgText }}</div>
                <div class="night-tag">{{ $t('night') }}</div>
            </div>
        </div>
        <div v-if="isApp && !isTHSApp()" @click.stop>
            <span
                @click.stop="$emit('attention')"
                v-if="!item.favorStatus"
                :class="[theme === 'black' ? 'information-icon-love black' : 'information-icon-love']"
            ></span>
            <span @click.stop="$emit('attention')" v-else class="information-icon-love active"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StockListItem',
    props: {
        item: { type: Object, required: true },
        theme: { type: String, required: true },
        mktColor: { type: Object, required: true },
        isApp: { type: Boolean, default: false },
        isTHSApp: { type: Function, default: () => false },
        showNight: { type: Boolean, default: false },
        itemHeight: { type: Number, default: 0 },
    },
    emits: ['click', 'attention'],
}
</script>

<style scoped lang="less">
@import url('~@/assets/css/mixins.less');
@import url('../css/mixins.less');

.stock-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    line-height: 22px;
    box-sizing: border-box;

    .import {
        color: #0569ff;
    }

    .title {
        align-items: center;
        justify-content: space-between;
        width: 70%;
        #stock_name();
    }

    .item-one {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-right: 8px;
        font-size: 16px;

        .list-title {
            max-width: 160px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            #font_h1();
        }

        .desc {
            padding: 0;
            font-size: 12px;
            color: #0569ff;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            #font_h3();
        }
    }

    .item-two {
        padding: 0 4px;
        color: #181818;
        #font_h1();

        .price {
            text-align: right;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            #stock_name();
        }
        .night-price {
            color: #666;
            text-align: right;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
            #night_price();
        }
    }

    .item-three {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        min-width: 80px;
        padding-right: 10px;

        .chgpct {
            font-size: 14px;
            text-align: right;
            font-weight: 400;
            line-height: 20px;
            #font_h1();
        }
        .night-three {
            display: flex;
            align-items: center;
            gap: 0 4px;
            height: 16px;
            line-height: 16px;
            .night-chg {
                color: #666;
                text-align: right;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px;
                #night_price();
            }
            .night-tag {
                display: flex;
                height: 14px;
                border: 1px solid transparent;
                padding: 2px 3px;
                justify-content: center;
                align-items: center;
                gap: 10px;
                border-radius: 1px;
                background: #f0f0f0;
                color: #666;
                font-size: 9px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px;
                #night_price();
            }
        }
    }
}

.information-icon-love {
    display: block;
    width: 16px;
    height: 16px;
    background: url('~@/assets/images/information/icon_love.png') no-repeat center;
    background-size: 100%;

    &.black {
        background: url('~@/assets/images/information/icon_love_black.png') no-repeat center;
        background-size: 100%;
    }

    &.active {
        background: url('~@/assets/images/information/icon_love_active.png') no-repeat center;
        background-size: 100%;
    }
}
</style>
